import styles from '../styles/Color.module.scss'
import { NextPage } from 'next';
import { Button, Card, Col, message, Row, Typography } from 'antd';
import React, { useState } from 'react';
import Link from 'next/link';
import { Download, Like } from '@icon-park/react';
import { http } from '../../utils/api'
import { colorLike } from '../../constants/api';
import { Item } from '../../@types/color';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import domtoimage from 'dom-to-image';
import { title } from '../../constants/heads';
import { useSelector } from 'react-redux';
import { State } from '../../@types/reducer';
const { Text } = Typography;
type Props = {
    item: Item
    imgUrl: string | string[]
    max: boolean | undefined
};
const Plate: NextPage<Props> = ({ item, max }) => {
    const { isXs, isSm, isMd, isXxl } = useSelector((state: State) => state.responsive)
    let ref: any = ""
    const { like_status } = item
    const [isDownload, setIsDownload] = useState(false);
    const [likeStatus, setLikeStatus] = useState(like_status)
    const [like, setLike] = useState(item.like)
    const likeFun = async () => {
        let res: any = await http(colorLike, { id: item._id })
        if (res.code == 200) {
            if (res.data.num == 1) {
                setLike(like + 1)
                setLikeStatus(true)
            } else {
                setLike(like - 1)
                setLikeStatus(false)
            }
        }
    }

    const handleClick = (e: any) => {
        // 阻止合成事件间的冒泡
        e.preventDefault();
    }

    const toPng = () => {
        setIsDownload(true)
        domtoimage.toPng(ref)
            .then((dataUrl) => {
                let link = document.createElement('a');
                link.download = `在线生成色板_${title}.png`;
                link.href = dataUrl;
                link.click();
                setIsDownload(false)
            })
            .catch((error) => {
                console.error('oops, something went wrong!', error);
            });
    }

    return (
        <div ref={(e) => ref = e}>
            <Card className={styles.plate} bodyStyle={max ? { height: isXs?'320px':'480px' } : {}} bordered={false}>
                {item.colors.map((v, k) => (
                    max ?
                        <CopyToClipboard text={v}
                            key={k}
                            onCopy={(e) => { message.success('复制成功') }}>

                            <a style={{ backgroundColor: v }}>
                                <span onClick={handleClick}>{v}</span>
                            </a>
                        </CopyToClipboard>
                        :
                        <Link key={k} href={`/color/${item._id}`}>
                            <a style={{ backgroundColor: v }} target="_blank">
                                <CopyToClipboard text={v}
                                    onCopy={(e) => { message.success('复制成功') }}>
                                    <span onClick={handleClick}>{v}</span>
                                </CopyToClipboard>
                            </a>
                        </Link>
                ))}
                {isDownload ? <div style={{ textAlign: 'center', paddingTop: '18px' }}><Text style={{ paddingBottom: 0 }} type="secondary">调色板由{title}在线生成</Text></div> : <Row style={{ paddingTop: '18px' }}>
                    <Col span={12}>
                        <Button onClick={likeFun} shape="round" icon={<Like theme={likeStatus ? "filled" : "outline"} size="14" fill={likeStatus ? '#ffdf29' : "#d9d9d9"} />} size="small">
                            &nbsp; {like}
                        </Button>
                        {max && <Button style={{ marginLeft: '15px' }} onClick={toPng} shape="round" icon={<Download theme="outline" size="14" fill="#333" strokeWidth={3} />} size="small">&nbsp; PNG</Button>}
                    </Col>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        {item.date}
                    </Col>
                </Row>}

            </Card>
        </div>
    )

}

export default Plate